var option_default = {
  "option": "lITw0",
  "user_choice": "b0rzl",
  "check": "cxrqO",
  "image": "yK-1q",
  "input": "nZzNJ",
  "title": "ICBRA",
  "centered": "oOe33",
  "with_result": "s8EUW",
  "list": "cOOTS",
  "with_image": "cZZq1",
  "progress": "tM9Fh",
  "progress_value": "qL-GK",
  "label": "XVXnI",
  "cta": "Vde1F",
  "adornment_icon": "N203V",
  "remove": "_2IWmh",
  "removeButton": "NMWxn",
  "removeButtonIcon": "NkUao",
  "overlay": "CAcvx",
  "shown": "hA-lH",
  "dark": "ayyBn",
  "spinner": "MyAoh",
  "spin": "r-iF4"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
